import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostListener,
  Input,
  OnInit,
  Output,
  Renderer2
} from '@angular/core'

import { PaymentSources } from '../../../enums/enums'
import { ICartGroup } from '../../../services/cart.service'
import { I18nService, LgType } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-confirmation-order-popup',
  templateUrl: './bmcore-confirmation-order-popup.component.html',
  styleUrls: ['./bmcore-confirmation-order-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreConfirmationOrderPopupComponent implements OnInit {
  @Input() group: ICartGroup
  @Input() paymentSource: PaymentSources
  @Input() colorSettingsMode = false
  @Input() widgetId: number

  @Output() switchConfirmationOrderPopup = new EventEmitter<boolean>()

  lg: LgType
  isLoader = false

  constructor(
    private i18nService: I18nService,
    private renderer: Renderer2
  ) {}

  ngOnInit() {
    this.isLoader = true
    this.lg = this.i18nService.getLanguageForPage()
  }

  closePopup() {
    this.switchConfirmationOrderPopup.emit(false)

    /* No parent scroll on modal scroll */
    this.renderer.removeClass(document.body, 'modal-open')
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDownHandler(event: KeyboardEvent) {
    if (event.key === 'Escape') {
      this.closePopup()
    }
  }

  hideSpinner() {
    this.isLoader = false
  }
}
